<!-- Alineado con page-header (container-fluid) y ancho del área bajo topbar + sidebar -->
<div class="container-fluid catalogs-page">
    <div class="card catalogs-card">
        <div class="card-body">
            <div id="batchDelete">
                <div class="row align-items-end justify-content-between flex-wrap catalogs-toolbar mb-3">
                    <div class="col-12 col-lg-5 mb-3 mb-lg-0" *ngIf="catalogName === 'services'">
                        <div class="form-group mb-0">
                            <h5 class="mb-2"><strong>Filtrar por área:</strong></h5>
                            <ng-select class="catalogs-ng-select" (change)="filterArea()" [(ngModel)]="departmentSelected">
                                <ng-option [value]="'Todos'">Todos</ng-option>
                                <ng-option *ngFor="let department of departments" [value]="department">
                                    {{department}}
                                </ng-option>
                            </ng-select>
                        </div>
                    </div>
                    <div class="col-12 col-lg-auto d-flex justify-content-lg-end">
                        <button *ngIf="catalogName === 'dependencias'; else areasBtn" type="button"
                            class="btn btn-primary catalogs-add-btn"
                            (click)="setModalContent(content, '')">+ Crear nueva dependencia</button>
                        <ng-template #areasBtn>
                            <button type="button" class="btn btn-primary catalogs-add-btn" (click)="setModalContent(content, '')">
                                Agregar
                            </button>
                        </ng-template>
                    </div>
                </div>

                <div *ngIf="catalogName === 'services'">
                    <div *ngIf="catalogs.length === 0">
                        <div class="col-sm-12 text-center section-b-space mt-5 no-found">
                            <img src="../../../assets/images/empty-search.jpg" class="img-fluid mb-4">
                            <h3>¡Lo sentimos! ¡No se han encontrado resultados! </h3>
                        </div>
                    </div>

                    <div class="table-responsive mt-5" *ngIf="catalogs.length > 0">
                        <table datatable [dtOptions]="dtOptions" class="table table-lg table-hover row-border hover">
                            <thead>
                                <tr>
                                    <th>Descripción Corta</th>
                                    <th>Descripción</th>
                                    <th>Área</th>
                                    <th>Etiquetas</th>
                                    <th>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let catalog of catalogs">
                                    <td>{{catalog.ShortDescription}}</td>
                                    <td>{{catalog.Description}}</td>
                                    <td>{{catalog.Department}}</td>
                                    <td>{{catalog.Tags}}</td>
                                    <td class="actions-cell">
                                        <span>
                                            <span (click)="setModalContent(content, catalog)" title="Editar"
                                                style="cursor: pointer;">
                                                <i class="fa fa-edit"></i>
                                            </span>
                                        </span>
                                        <span title="Borrar" (click)="setModalContent(contentDelete,catalog)">
                                            <i class="fa fa-trash"></i>
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <ngb-pagination (pageChange)="loadPage($event)" [collectionSize]="total" [(page)]="page"
                            [maxSize]="10" [rotate]="true" [boundaryLinks]="true"></ngb-pagination>
                    </div>
                </div>

                <div *ngIf="catalogName === 'reportes'">
                    <!-- Buscador -->
                    <div class="row mb-3 mt-3">
                        <div class="col-md-6">
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fa fa-search"></i></span>
                                </div>
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Buscar por descripción, área o etiquetas..."
                                    [(ngModel)]="reporteSearchValue"
                                    (input)="onReporteSearchInput()">
                                <div class="input-group-append" *ngIf="reporteSearchValue">
                                    <button class="btn btn-outline-secondary" type="button" (click)="clearReporteSearch()">
                                        <i class="fa fa-times"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <select class="form-control" [(ngModel)]="reporteQuickAccessFilter" (ngModelChange)="filterReportes()">
                                <option value="">Todos</option>
                                <option value="true">Acceso rápido: Sí</option>
                                <option value="false">Acceso rápido: No</option>
                            </select>
                        </div>
                    </div>

                    <div *ngIf="filteredReportes.length === 0">
                        <div class="col-sm-12 text-center section-b-space mt-5 no-found">
                            <img src="../../../assets/images/empty-search.jpg" class="img-fluid mb-4">
                            <h3>¡Lo sentimos! ¡No se han encontrado resultados! </h3>
                        </div>
                    </div>

                    <div class="table-responsive mt-3" *ngIf="filteredReportes.length > 0">
                        <table datatable [dtOptions]="dtOptions" class="table table-lg table-hover row-border hover">
                            <thead>
                                <tr>
                                    <th>Descripción Corta</th>
                                    <th>Descripción</th>
                                    <th>Área</th>
                                    <th>Etiquetas</th>
                                    <th>Acceso rápido</th>
                                    <th>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let catalog of filteredReportes">
                                    <td>{{catalog.ShortDescription}}</td>
                                    <td>{{catalog.Description}}</td>
                                    <td>{{catalog.Department}}</td>
                                    <td>{{catalog.Tags}}</td>
                                    <td class="text-center">
                                        <span *ngIf="catalog.QuickAccess" class="badge badge-success">Sí</span>
                                        <span *ngIf="!catalog.QuickAccess" class="badge badge-secondary">No</span>
                                    </td>
                                    <td class="actions-cell">
                                        <span (click)="setModalContent(content, catalog)" title="Editar"
                                            style="cursor: pointer;">
                                            <i class="fa fa-edit"></i>
                                        </span>
                                        <span title="Borrar" (click)="setModalContent(contentDelete,catalog)" style="cursor: pointer; margin-left: 8px;">
                                            <i class="fa fa-trash"></i>
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <ngb-pagination (pageChange)="loadPage($event)" [collectionSize]="total" [(page)]="page"
                            [maxSize]="10" [rotate]="true" [boundaryLinks]="true"></ngb-pagination>
                    </div>
                </div>

                <div *ngIf="catalogName !== 'services' && catalogName !== 'reportes' && catalogName !== 'codigos-scian' && catalogName !== 'turnos'">
                    <div class="table-responsive mt-5" *ngIf="catalogs.length > 0">
                        <table datatable [dtOptions]="dtOptions" class="table table-lg table-hover row-border hover catalogs-table">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Abreviatura</th>
                                    <th>
                                        <ng-container [ngSwitch]="catalogName">
                                            <ng-container *ngSwitchCase="'dependencias'">Dependencia</ng-container>
                                            <ng-container *ngSwitchCase="'areas'">Área</ng-container>
                                            <ng-container *ngSwitchCase="'sources'">Fuente</ng-container>
                                            <ng-container *ngSwitchCase="'users'">Perfil</ng-container>
                                            <ng-container *ngSwitchCase="'tipos-documento'">Tipo de documento</ng-container>
                                            <ng-container *ngSwitchDefault>Descripción</ng-container>
                                        </ng-container>
                                    </th>
                                    <th>Siglas</th>
                                    <th>
                                        <ng-container [ngSwitch]="catalogName">
                                            <ng-container *ngSwitchCase="'dependencias'">Encargado</ng-container>
                                            <ng-container *ngSwitchDefault>Nombre del director</ng-container>
                                        </ng-container>
                                    </th>
                                    <th>Opciones</th>
                                    <th class="text-center">Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let catalog of catalogs">
                                    <td>{{catalog?.id}}</td>
                                    <td>{{catalog?.Alias}}</td>
                                    <td>{{catalog?.ValueAlpha}}</td>
                                    <td>{{catalog?.abbreviation || "-"}}</td>
                                    <td>{{catalog?.nameDirector || "-"}}</td>
                                    <td>{{catalog?.options || "-"}}</td>
                                    <td class="actions-cell text-center">
                                        <span (click)="setModalContent(content,catalog)" title="Editar"
                                            style="cursor: pointer;">
                                            <i class="fa fa-edit"></i>
                                        </span>
                                        <span title="Borrar" (click)="setModalContent(contentDelete,catalog)">
                                            <i class="fa fa-trash"></i>
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <ngb-pagination (pageChange)="loadPage($event)" [collectionSize]="total" [(page)]="page"
                            [maxSize]="10" [rotate]="true" [boundaryLinks]="true"></ngb-pagination>
                    </div>
                </div>
                <!-- ── Turnos ──────────────────────────────────────── -->
                <div *ngIf="catalogName === 'turnos'">
                    <div *ngIf="catalogs.length === 0" class="col-sm-12 text-center section-b-space mt-5 no-found">
                        <h3>No se han encontrado turnos.</h3>
                    </div>
                    <div class="table-responsive mt-4" *ngIf="catalogs.length > 0">
                        <table datatable [dtOptions]="dtOptions" class="table table-lg table-hover row-border hover">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Nombre del Turno</th>
                                    <th>Hora Inicio</th>
                                    <th>Hora Fin</th>
                                    <th class="text-center">Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let catalog of catalogs">
                                    <td>{{ catalog?.id }}</td>
                                    <td><strong>{{ catalog?.ValueAlpha }}</strong></td>
                                    <td>{{ catalog?.ValueBeta || '—' }}</td>
                                    <td>{{ catalog?.ValueGamma || '—' }}</td>
                                    <td class="actions-cell text-center">
                                        <span (click)="setModalContent(content, catalog)" title="Editar" style="cursor:pointer;">
                                            <i class="fa fa-edit"></i>
                                        </span>
                                        <span title="Borrar" (click)="setModalContent(contentDelete, catalog)" style="cursor:pointer; margin-left:8px;">
                                            <i class="fa fa-trash"></i>
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <ngb-pagination (pageChange)="loadPage($event)" [collectionSize]="total" [(page)]="page"
                            [maxSize]="10" [rotate]="true" [boundaryLinks]="true"></ngb-pagination>
                    </div>
                </div>

                <!-- ── Códigos SCIAN ──────────────────────────────── -->
                <div *ngIf="catalogName === 'codigos-scian'">
                    <div *ngIf="catalogs.length === 0" class="col-sm-12 text-center section-b-space mt-5 no-found">
                        <h3>No se han encontrado códigos SCIAN.</h3>
                    </div>
                    <div class="table-responsive mt-4" *ngIf="catalogs.length > 0">
                        <table datatable [dtOptions]="dtOptions" class="table table-lg table-hover row-border hover">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Clave SCIAN</th>
                                    <th>Descripción de la actividad</th>
                                    <th class="text-center">Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let catalog of catalogs">
                                    <td>{{ catalog?.id }}</td>
                                    <td><strong>{{ catalog?.ValueAlpha }}</strong></td>
                                    <td>{{ catalog?.Description || '—' }}</td>
                                    <td class="actions-cell text-center">
                                        <span (click)="setModalContent(content, catalog)" title="Editar" style="cursor:pointer;">
                                            <i class="fa fa-edit"></i>
                                        </span>
                                        <span title="Borrar" (click)="setModalContent(contentDelete, catalog)" style="cursor:pointer; margin-left:8px;">
                                            <i class="fa fa-trash"></i>
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <ngb-pagination (pageChange)="loadPage($event)" [collectionSize]="total" [(page)]="page"
                            [maxSize]="10" [rotate]="true" [boundaryLinks]="true"></ngb-pagination>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>
<!-- Container-fluid Ends-->

<ng-template #content let-modal>
    <div class="modal-header">
        <h4 class="modal-title text-center width-100" id="modal-title" *ngIf="catalogName === 'areas'">{{onEdit ?
            'Editar Área':'Agregar Área'}}</h4>
        <h4 class="modal-title text-center width-100 title-modal" id="modal-title"
            *ngIf="catalogName === 'dependencias'">{{onEdit ? 'Editar Dependencia':'Crear Dependencia'}}</h4>
        <h4 class="modal-title text-center width-100" id="modal-title" *ngIf="catalogName === 'services'">{{onEdit ?
            'Editar Servicio':'Agregar Servicio'}}</h4>
        <h4 class="modal-title text-center width-100" id="modal-title" *ngIf="catalogName === 'sources'">{{onEdit ?
            'Editar Fuente' :'Agregar Fuente'}}</h4>
        <h4 class="modal-title text-center width-100" id="modal-title" *ngIf="catalogName === 'users'">{{onEdit ?
            'Editar Perfil':'Agregar Perfil'}}</h4>
        <h4 class="modal-title text-center width-100" id="modal-title" *ngIf="catalogName === 'reportes'">{{onEdit ?
            'Editar Tipo de Reporte':'Agregar Tipo de Reporte'}}</h4>
        <h4 class="modal-title text-center width-100" id="modal-title" *ngIf="catalogName === 'codigos-scian'">
            {{ onEdit ? 'Editar Código SCIAN' : 'Agregar Código SCIAN' }}
        </h4>
        <h4 class="modal-title text-center width-100" id="modal-title" *ngIf="catalogName === 'turnos'">
            {{ onEdit ? 'Editar Turno' : 'Agregar Turno' }}
        </h4>

    </div>
    <div class="modal-body text-center">
        <ng-container *ngIf="!isSuccess && catalogName === 'services'">
            <form [formGroup]="problemForm">
                <div class="form-group">
                    <h5>Descripción Corta:</h5>
                    <input class="form-control" type="text" formControlName="ShortDescription">
                </div>
                <div class="form-group">
                    <h5>Descripción:</h5>
                    <input class="form-control" type="text" formControlName="Description">
                </div>
                <div class="form-group">
                    <h5>Área:</h5>
                    <ng-select formControlName="Department">
                        <ng-option *ngFor="let department of departments" [value]="department">
                            {{department}}
                        </ng-option>
                    </ng-select>
                </div>
                <div class="form-group">
                    <h5>Etiquetas (para futuras consultas):</h5>
                    <input class="form-control" type="text" formControlName="Tags">
                </div>
            </form>
        </ng-container>

        <ng-container *ngIf="!isSuccess && catalogName === 'reportes'">
            <form [formGroup]="problemForm">
                <div class="form-group">
                    <h5>Descripción Corta:</h5>
                    <input class="form-control" type="text" formControlName="ShortDescription">
                </div>
                <div class="form-group">
                    <h5>Descripción:</h5>
                    <input class="form-control" type="text" formControlName="Description">
                </div>
                <div class="form-group">
                    <h5>Área:</h5>
                    <ng-select formControlName="Department">
                        <ng-option *ngFor="let department of departments" [value]="department">
                            {{department}}
                        </ng-option>
                    </ng-select>
                </div>
                <div class="form-group">
                    <h5>Etiquetas (para futuras consultas):</h5>
                    <input class="form-control" type="text" formControlName="Tags">
                </div>
                <div class="form-group d-flex align-items-center">
                    <label class="mb-0 mr-3"><h5 class="mb-0">Acceso rápido:</h5></label>
                    <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" id="quickAccessCheck"
                            [(ngModel)]="quickAccessValue" [ngModelOptions]="{standalone: true}">
                        <label class="custom-control-label" for="quickAccessCheck">
                            {{quickAccessValue ? 'Sí' : 'No'}}
                        </label>
                    </div>
                </div>
            </form>
        </ng-container>

        <ng-container *ngIf="!isSuccess && catalogName !== 'services' && catalogName !== 'reportes' && catalogName !== 'codigos-scian' && catalogName !== 'turnos'">

            <ng-container *ngIf="!isSuccess && catalogName == 'dependencias'; else areas">
                <div class="mt-5">
                    <h5 class="subtitle-modal"> Nombre de dependencia <b class="asterisk-modal">*</b></h5>
                    <input class="form-control input-modal" placeholder="Seleccione dependencia"
                        [(ngModel)]="valueAlpha">
                </div>
                <div class="mt-5">
                    <h5 class="subtitle-modal">Abreviatura <b class="asterisk-modal">*</b></h5>
                    <input class="form-control" type="text" [(ngModel)]="abbreviation">
                </div>
                <div class="mt-5">
                    <h5 class="subtitle-modal">Encargado de dependencia <b class="asterisk-modal">*</b></h5>
                    <input class="form-control" placeholder="Seleccione encargado de área" [(ngModel)]="nameDirector">
                </div>
                <div class="mt-5">
                    <h5 class="subtitle-modal"><b class="asterisk-modal">*</b> Campos obligatorios</h5>
                    <input class="form-control" type="text" [(ngModel)]="options">
                </div>
            </ng-container>
            <ng-template #areas>
                <div class="mt-4">
                    <h5>Nombre:</h5>
                    <input class="form-control" type="text" [(ngModel)]="valueAlpha">
                </div>
            </ng-template>

            <div class="error" *ngIf="!responseValidate">Campo nombre obligatorio.</div>
        </ng-container>

        <!-- ── Turnos ────────────────────────────────── -->
        <ng-container *ngIf="!isSuccess && catalogName === 'turnos'">
            <div class="mt-3">
                <label><h5>Nombre del Turno <b class="asterisk-modal">*</b></h5></label>
                <input class="form-control" type="text" [(ngModel)]="valueAlpha"
                       placeholder="Ej. Turno Matutino">
            </div>
            <div class="mt-3 row">
                <div class="col-6">
                    <label><h5>Hora Inicio <b class="asterisk-modal">*</b></h5></label>
                    <input class="form-control" type="time" [(ngModel)]="valueDescription"
                           placeholder="08:00">
                </div>
                <div class="col-6">
                    <label><h5>Hora Fin <b class="asterisk-modal">*</b></h5></label>
                    <input class="form-control" type="time" [(ngModel)]="abbreviation"
                           placeholder="16:00">
                </div>
            </div>
        </ng-container>

        <!-- ── Códigos SCIAN ────────────────────────────────── -->
        <ng-container *ngIf="!isSuccess && catalogName === 'codigos-scian'">
            <div class="mt-3">
                <label><h5>Clave SCIAN <b class="asterisk-modal">*</b></h5></label>
                <input class="form-control" type="text" [(ngModel)]="valueAlpha"
                       placeholder="Ej. 462111" maxlength="10">
            </div>
            <div class="mt-3">
                <label><h5>Descripción de la actividad <b class="asterisk-modal">*</b></h5></label>
                <textarea class="form-control" rows="3" [(ngModel)]="valueDescription"
                          placeholder="Ej. Comercio al por menor de abarrotes"></textarea>
            </div>
        </ng-container>

        <!-- <ng-container *ngIf="isSuccess">
            <p>Valor agregado correctamente</p>
        </ng-container> -->
    </div>
    <div class="modal-footer">
        <a type="button" class="btn btn-outline-light cancel-btn" (click)="modal.close()">Cancelar </a>
        <button [disabled]="isLoading" class="btn btn-primary submit-btn" (click)="onSubmit()">{{onEdit ? 'Editar' :
            'Guardar'}}</button>
    </div>

</ng-template>


<ng-template #contentDelete let-modal>
    <div class="modal-header">
        <h4 class="modal-title text-center width-100" id="modal-title" *ngIf="catalogName === 'areas'">Eliminar Área
        </h4>
        <h4 class="modal-title text-center width-100" id="modal-title" *ngIf="catalogName === 'services'">Eliminar
            Servicio</h4>
        <h4 class="modal-title text-center width-100" id="modal-title" *ngIf="catalogName === 'sources'">Eliminar Fuente
        </h4>
        <h4 class="modal-title text-center width-100" id="modal-title" *ngIf="catalogName === 'users'">Eliminar Perfil
        </h4>
        <h4 class="modal-title text-center width-100" id="modal-title" *ngIf="catalogName === 'tipos-documento'">Eliminar Tipo de documento
        </h4>
        <h4 class="modal-title text-center width-100" id="modal-title" *ngIf="catalogName === 'reportes'">Eliminar Tipo de Reporte
        </h4>
        <h4 class="modal-title text-center width-100" id="modal-title" *ngIf="catalogName === 'turnos'">Eliminar Turno
        </h4>
    </div>
    <div class="modal-body text-center">
        <ng-container *ngIf="!deleteIsSuccess">
            <p class="no-mrg">Se eliminarán todos los datos del catálogo.</p>
            <p class="no-mrg">Esta acción no se puede deshacer.</p>
        </ng-container>

        <!-- <ng-container *ngIf="deleteIsSuccess">
      <p>Datos borrados correctamente</p>
    </ng-container> -->
    </div>
    <ng-container *ngIf="!deleteIsSuccess">
        <div class="modal-footer">
            <a type="button" class="btn btn-outline-light" (click)="modal.close()">Cancelar</a>
            <button type="button" class="btn btn-inverse btn-danger" (click)="deleteCatalog()"
                [disabled]="isLoading">Eliminar</button>
        </div>
    </ng-container>
</ng-template>

